import * as React from "react";
import { forwardRef } from "react";
const SvgPodcastPlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 20, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.53674e-07 -6.99382e-07L16 10L7.94463e-08 20" }));
const ForwardRef = forwardRef(SvgPodcastPlay);
export { ForwardRef as ReactComponent };
